import { Reducer } from 'redux'
import { toast } from 'react-toastify'
import { put, takeLatest, all } from 'redux-saga/effects'
import { SagaAction, GetResponse } from 'src/@types'
import { API } from 'src/services/config'

export interface SettingsProps {
  ancpAnimalMostrarProp: string
  ancpHabilitado: string
  ancpNfa: string
  ancpNfo: string
  id: string
  idFazenda: string
  key: string
}

export interface StoreProps {
  ancpAnimalMostrarProp: string
  ancpHabilitado: string
  ancpNfa: string
  ancpNfo: string
  id: string
  idFazenda: string
  key: string
}

export interface FarmState {
  list: Array<SettingsProps>
}

const customModule = '@SETTINGS'

const UPDATE = {
  REQUEST: `${customModule}/UPDATE_REQUEST`,
  SUCCESS: `${customModule}/UPDATE_SUCCESS`,
}

const SET_FETCHING = `${customModule}/SET_FETCHING`

const initialState: FarmState = {
  list: [],
}

export const settingsReducer: Reducer = (state = initialState, { type, payload }) => {
  switch (type) {

  case UPDATE.SUCCESS: {
    const { list } = state
    const newList = list.map((item: any) => {
      if (item.idFazenda === payload.idFazenda) return payload
      return item
    })
    return { ...state, list: newList }
  }

  default:
    return state
  }
}

export const setFetching = (data: boolean) => ({ type: SET_FETCHING, payload: data })
export const updateSettings = (data: StoreProps) => ({ type: UPDATE.REQUEST, payload: data })


const ROUTE = '/entity/FazendaConfiguracao'

// eslint-disable-next-line
function* update({ payload }: SagaAction<StoreProps>) {
  try {
    yield put(setFetching(true))
    const { data }: GetResponse<any> = yield toast.promise(
      API.put(ROUTE, payload),
      {
        pending: 'Processando...',
        success: {
          render() {
            return 'Atualizado com Sucesso!'
          },
          delay: 800,
        },
        error: {
          render({ data: { response } }: any) {
            return response?.data || 'Erro ao Atualizar'
          },
          delay: 800,
        },
      },
    )
    yield put({ type: UPDATE.SUCCESS, payload: data })
    yield put(setFetching(false))
  } catch {
    yield put(setFetching(false))
  }
}

export const settingsSaga = all([
  takeLatest(UPDATE.REQUEST, update),
])
